// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ReturnOrderManifestProperty } from '@/audit/api/types';
import { AuditOrderManifestLabel } from '@/audit/components/audit-order-manifest-label';

interface Props {
  property: ReturnOrderManifestProperty;
}

/**
 * Renders a return order's line-item manifest as an old→new diff. Authored
 * manifests carry the requested quantity; a shipment-cascade sync also carries the
 * open, shipped, delivered, and received tiers. The tiers read in the order goods
 * move, so a receive shows units leaving delivered and landing in received.
 */
export function AuditReturnOrderManifestLabel(props: Props) {
  return (
    <AuditOrderManifestLabel
      name={props.property.name}
      oldValue={props.property.oldValue}
      newValue={props.property.newValue}
      tiers={(oldEntry, newEntry) => [
        {
          label: 'Requested',
          old: oldEntry.requestedQuantity,
          new: newEntry.requestedQuantity,
        },
        {
          label: 'Open',
          old: oldEntry.openQuantity ?? null,
          new: newEntry.openQuantity ?? null,
        },
        {
          label: 'Shipped',
          old: oldEntry.shippedQuantity ?? null,
          new: newEntry.shippedQuantity ?? null,
        },
        {
          label: 'Delivered',
          old: oldEntry.deliveredQuantity ?? null,
          new: newEntry.deliveredQuantity ?? null,
        },
        {
          label: 'Quarantined',
          old: oldEntry.quarantinedQuantity ?? null,
          new: newEntry.quarantinedQuantity ?? null,
        },
        {
          label: 'Received',
          old: oldEntry.receivedQuantity ?? null,
          new: newEntry.receivedQuantity ?? null,
        },
      ]}
    />
  );
}
